import { formatCurrency } from '../format';
import { useInView } from '../hooks/useInView';
import type { Plan } from '../types';
import { ArrowRight } from './ArrowRight';
import { Checkmark } from './Checkmark';
import { StarCircle } from './StarCircle';

interface PlanCardProps {
  plan: Plan;
  signupUrl: string;
}

export const PlanCard = ({ plan, signupUrl }: PlanCardProps) => {
  const [ref, inView] = useInView<HTMLDivElement>();
  const { units, remainder, priceDivider } = formatCurrency(plan.price, plan.currency_code);

  return (
    <div ref={ref} className={`plan-card${inView ? ' in-view' : ''}`}>
      <div className="plan-flag">Recommended for you</div>
      <h3 className="plan-heading">{plan.plan_name}</h3>

      <div className="plan-price">
        <span className="plan-price-large">{units}</span>
        {priceDivider}
        {remainder}
        <span className="plan-price-month"> /month</span>
      </div>

      <ul className="plan-features">
        <li className="plan-features-item">
          <StarCircle size={20} />
          <span>
            <strong>
              {plan.plan_credits} Premium track credit{plan.plan_credits === 1 ? '' : 's'}
            </strong>{' '}
            per month
          </span>
        </li>
        <li className="plan-features-item">
          <Checkmark size={20} /> Unlimited Royalty Free tracks
        </li>
        <li className="plan-features-item">
          <Checkmark size={20} />
          <span>
            <strong>Exclusive subscriber discount</strong> on additional Premium tracks
          </span>
        </li>
        <li className="plan-features-item">
          <Checkmark size={20} />
          All mainstream tracks are claims-managed, keeping your content safe
        </li>
      </ul>

      <a className="btn btn-primary cta-btn" href={signupUrl} target="_blank" rel="noopener noreferrer">
        Sign up
        <ArrowRight />
      </a>
    </div>
  );
};
